<template>
  <div class="user-permission-list page-box">
    <div class="page-content">
      <div class="content-header">
        <el-input
          v-model="userName"
          placeholder="用户名"
          clearable
          class="search-input"
        ></el-input>
        <vs-button
          style="margin-left: 10px"
          class="search-btn btn box-item"
          @click="searchHandle"
        >刷新</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              用户名称
            </vs-th>
            <vs-th>
              维度表
            </vs-th>
            <vs-th>
              表字段
            </vs-th>
            <vs-th>
              权限值
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.username}}
              </vs-td>
              <vs-td>
                {{tr.tableName}}
              </vs-td>
              <vs-td>
                {{tr.columnName}}
              </vs-td>
              <vs-td>
                {{tr.columnValue}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import initData from "@/mixins/initData";
export default {
  name: "index",
  components: {
  },
  data() {
    return {


      red: '#D85E5F',
      green: '#41B883',
      userName: '',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    beforeInit(){
      this.url = '/wx/sys/dataPermissionGen/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc'
      }
      if(this.userName){
        this.params.username = this.userName;
      }
      return true;
    },

    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.user-permission-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
